import { LOGOUT_USER } from "../../ActionTypes";

export const logoutApp = (history, resetPortalContext) => (dispatch) => {
  history.push("/");
  sessionStorage.removeItem("token");
  dispatch({ type: LOGOUT_USER });
  if (resetPortalContext) resetPortalContext(0);
  localStorage.removeItem("isAdmin");
  localStorage.removeItem("token");
};
